var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHeroIllustration(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 1265,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-17.6%",
    y: "-34.2%",
    width: "135.1%",
    height: "168.4%",
    filterUnits: "objectBoundingBox",
    id: "b"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 50,
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-23.6%",
    y: "-187.5%",
    width: "147.2%",
    height: "475%",
    filterUnits: "objectBoundingBox",
    id: "d"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 50,
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-23.6%",
    y: "-187.5%",
    width: "147.2%",
    height: "475%",
    filterUnits: "objectBoundingBox",
    id: "e"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 50,
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-23.6%",
    y: "-187.5%",
    width: "147.2%",
    height: "475%",
    filterUnits: "objectBoundingBox",
    id: "g"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 50,
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "98.284%",
    y1: "37.276%",
    x2: "9.488%",
    y2: "37.276%",
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6366F1",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6366F1",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "100%",
    y1: "37.276%",
    x2: "9.488%",
    y2: "37.276%",
    id: "c"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#38BDF8",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#38BDF8",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "100%",
    y1: "37.276%",
    x2: "9.488%",
    y2: "37.276%",
    id: "f"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6EE7B7",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6EE7B7",
    stopOpacity: 0,
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    filter: "url(#b)",
    d: "M262.132 307.493 253.019 438.5l844.887-307.493L1107.019 0z",
    transform: "translate(-.103 -152)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    filter: "url(#d)",
    transform: "rotate(-20 296.964 770.578)",
    d: "m446.117 806.285-35.584 80h599.418l35.582-80z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    filter: "url(#e)",
    transform: "rotate(-20 29.964 1143.578)",
    d: "m179.117 1179.285-35.584 80h599.418l35.582-80z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#f)",
    filter: "url(#g)",
    transform: "rotate(-20 156.964 105.578)",
    d: "m306.117 141.285-35.584 80h599.418l35.582-80z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroIllustration);
export default __webpack_public_path__ + "static/media/hero-illustration.a4c71c66c38933009a176f29d5801780.svg";
export { ForwardRef as ReactComponent };